import React, { ReactNode } from 'react'
import { cn } from 'src/lib/utils'

interface WorkoutCardOverlayProps {
  children: ReactNode
  className?: string
}

export const WorkoutCardOverlay = ({ children, className }: WorkoutCardOverlayProps): React.ReactElement => {
  return <div className={cn('absolute inset-0 flex flex-col justify-end', className)}>{children}</div>
}
